// 绝对日期格式化：YYYY-MM-DD（date-only）。复用 formatDateTime 的 Intl 方案、去掉时分；
// 用平台内置 Intl（浏览器 / Node 皆有，零依赖）按「运行时本地时区」换算（不传 timeZone 即跟随用户浏览器时区），
// 用 formatToParts 自己拼装，锁死格式不受系统 locale 影响。
export const formatDate = (date: Date): string => {
  const parts = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date)
  const pick = (type: Intl.DateTimeFormatPartTypes): string => parts.find(p => p.type === type)?.value ?? ''
  return `${pick('year')}-${pick('month')}-${pick('day')}`
}
